import Radio from "backbone.radio";
import { nextTick } from "common/utils";

import moment from "moment";
import { createRef, Component } from "react";
import classNames from "classnames";
import { Tooltip } from "common/components/tooltip";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/pro-solid-svg-icons";

export class MonthlyCalendar extends Component {
    static defaultProps = {
        currentYear: moment().year(),
        currentQuarter: moment().quarter()
    };
    
    constructor(props) {
        super(props);
        this.startYear = new Date(this.props.startYear).getFullYear();
        this.scrollableContainerRef = createRef();
    }
    
    componentDidMount() {
        this.centerRangeInView();
    }
    
    processMonthClick = (date, { locked, future }) => (e) => {
        e.preventDefault();
        if (locked) {
            Radio.channel("main").request("show:package:compare");
            return;
        }
        
        if (future) return;
        
        this.props.selectDate(date);
    };
    
    selectFullQuarter = (year, quarter) => (e) => {
        e.preventDefault();
        // Select start date
        const start = moment.utc().year(year).quarter(quarter).startOf("quarter");
        if (this.props.isPermittedDate(start)) {
            this.props.selectDate(start);
        } else {
            Radio.channel("main").request("show:package:compare");
            return;
        }
        
        // Select end date
        this.props.selectDate(moment.utc().year(year).quarter(quarter).endOf("quarter"));
    };
    
    isStartMonth(year, month) {
        return this.props.startDate && year === this.props.startDate.year() && month === this.props.startDate.month();
    }
    
    isEndMonth(year, month) {
        return this.props.endDate && year === moment(this.props.endDate).year() && month === moment(this.props.endDate).month();
    }
    
    isBetween(year, month) {
        return (this.props.startDate && this.props.endDate)
            && moment.utc(`${year}-${month + 1}`, "YYYY-M").isBetween(this.props.startDate, this.props.endDate, "months", "[]");
    }
    
    centerRangeInView() {
        nextTick(() => {
            try {
                const parentOffset = this.scrollableContainerRef.current.offsetTop;
                const targetOffset = this.scrollableContainerRef.current.querySelector(".month.start").offsetTop;
    
                this.scrollableContainerRef.current.scrollTop = targetOffset - parentOffset;
            } catch {
                // Noop. We should not error here because running the op in nextTick.
            }
        });
    }
    
    renderMonth(year, month) {
        const momentMonth = moment(`${year}-${month + 1}`, "YYYY-M");
        const monthAnalysis = {
            start: this.isStartMonth(year, month),
            end: this.isEndMonth(year, month),
            selected: this.isBetween(year, month),
            available: this.props.isPermittedDate(momentMonth),
            toolTip: this.props.dateTooltip(momentMonth),
            get locked() {
                return !this.available;
            },
            get disabled() {
                return !this.available;
            },
            future: momentMonth.isAfter(moment.utc().endOf("month")) || momentMonth.isAfter(this.props.maxDate),
            past: momentMonth.isBefore(moment.utc().startOf("month").subtract(25, "months"))
        };
        
        return (
            <Tooltip title={monthAnalysis.toolTip}>
                <div
                    className={classNames("month", monthAnalysis)}
                    key={`${year}-${month}`}
                    onClick={this.processMonthClick(moment.utc(`${year}-${month + 1}`, "YYYY-M"), monthAnalysis)}
                >
                    {monthAnalysis.locked && <span className="lock-icon"><FontAwesomeIcon icon={faLock}/></span>}
                    {momentMonth.format("MMMM")}
                </div>
            </Tooltip>
        );
    }
    
    renderQuarter(year, quarter) {
        return (
            <div className={`monthly-year-row row-${quarter}`} key={`${year}-${quarter}`}>
                <div className="quarter" onClick={this.selectFullQuarter(year, quarter)}>Q{quarter}</div>
                {Array.from({ length: 3 }).fill(null).map((item, index) => this.renderMonth(year, (quarter - 1) * 3 + index))}
            </div>
        );
    }
    
    renderYear(year) {
        return (
            <div className="year" key={year}>
                <div className="monthly-header">{year}</div>
                {Array.from({ length: 4 }).fill(null).map((item, index) => this.renderQuarter(year, index + 1))}
            </div>
        );
    }
    
    render() {
        // Use start year as year merchant config was created
        const yearsToRender = [];
        for (let y = this.startYear; y <= this.props.currentYear; y++) {
            yearsToRender.push(y);
        }
        return (
            <div className="monthly" ref={this.scrollableContainerRef}>
                {yearsToRender.map((year) => this.renderYear(year))}
                {this.props.currentQuarter === 4 && this.renderYear(this.props.currentYear + 1)}
            </div>
        );
    }
}
